<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em">To my Andromeda, who came into this world on Thursday, May 1, 1963, and left it on Tuesday, January 14, 1986:</p><br/>
<p style="text-indent:0em">A slumber did my spirit steal</p>
<p style="text-indent:0em">I had no human fears</p>
<p style="text-indent:0em">She seemed a thing that could not feel</p>
<p style="text-indent:0em">The touch of earthly years</p>
<p style="text-indent:0em">No motion has she now—no force</p>
<p style="text-indent:0em">She neither feels nor sees</p>
<p style="text-indent:0em">Wrapped round in earth’s diurnal course</p>
<p style="text-indent:0em">With rocks—and stones—and trees</p><br/>
<p style="text-indent:0em">Words by William Wordsworth, engraved on the tomb of Andromeda James.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?73883d86